import { Component, OnInit, ContentChild } from "@angular/core";
import {
  NgbActiveModal,
  NgbDateStruct,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { OrderItemComponent } from "./../order-item/order-item.component";
import {
  PurchaseOrderService,
  PurchaseOrderDto,
  EPaymentStatus,
  ECurrency,
} from "../../../api";
import { ToastService } from "../../../../shared/service/toast.service";
import { CustomdatepickerComponent } from "../../../../shared/modules/customdatepicker.component";

@Component({
  selector: "app-order",
  templateUrl: "./order.component.html",
  styleUrls: ["./order.component.scss"],
})
export class OrderComponent implements OnInit {
  @ContentChild(CustomdatepickerComponent)
  datepickerViewChild: CustomdatepickerComponent;

  keys = Object.keys;
  paymentForm: FormGroup;
  data = {
    purchaseOrderId: 0,
    dueDate: 0,
    status: EPaymentStatus.Pending,
    currency: ECurrency.Dkk,
    caseId: 0,
    note: "",
    purchaseOrderItems: [],
  };
  loading = false;
  items = [];
  currencies = ECurrency;
  today = new Date();
  minDate = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate(),
  };
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private toast: ToastService,
    private ps: PurchaseOrderService
  ) {}

  ngOnInit() {
    // older purchase orders hold the swagger placeholder instead of a note
    if (this.data.note === "string") {
      this.data.note = "";
    }
    const dt = new Date();
    const date = {
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
      day: dt.getDate(),
    };
    this.paymentForm = new FormGroup({
      date: new FormControl(date, [Validators.required]),
      currency: new FormControl(ECurrency.Dkk, [Validators.required]),
      notify: new FormControl(true),
    });
  }
  addItem() {
    const modalRef = this.modalService.open(OrderItemComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.currency = this.data.currency;
    modalRef.result
      .then((result) => {
        result.quantity = parseFloat(result.quantity);
        result.total = parseFloat(result.total);
        this.data.purchaseOrderItems.push(result);
      })
      .catch((error) => {});
  }
  editItem(item) {
    const idx = this.data.purchaseOrderItems.indexOf(item);
    const modalRef = this.modalService.open(OrderItemComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.data = Object.assign({}, item);
    modalRef.componentInstance.currency = this.data.currency;
    modalRef.result
      .then((result) => {
        result.quantity = parseFloat(result.quantity);
        result.total = parseFloat(result.total);
        this.data.purchaseOrderItems[idx] = result;
      })
      .catch((error) => {});
  }
  removeItem(item) {
    const idx = this.data.purchaseOrderItems.indexOf(item);
    this.data.purchaseOrderItems.splice(idx, 1);
  }
  getSubTotal() {
    const total = this.getTotal();
    return parseFloat(total) * 0.8;
  }
  getTax() {
    const total = this.getTotal();
    return parseFloat(total) * 0.2;
  }
  getTotal() {
    let total = 0;
    this.data.purchaseOrderItems.forEach((item) => {
      total += parseFloat(item.total) * parseFloat(item.quantity);
    });
    return total.toFixed(2);
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  saveModal() {
    if (!this.loading) {
      this.loading = true;
      const date = new Date(
        this.paymentForm.value.date.year,
        this.paymentForm.value.date.month,
        this.paymentForm.value.date.day
      );
      this.data.dueDate = Math.floor(date.getTime() / 1000);
      if (this.data.purchaseOrderId) {
        this.ps.apiPurchaseOrdersPut(false, this.data).subscribe(
          (data) => {
            this.activeModal.close();
          },
          (error) => {
            this.loading = false;
          }
        );
      } else {
        this.ps.apiPurchaseOrdersPost(this.data).subscribe(
          (data) => {
            this.activeModal.close();
          },
          (error) => {
            this.loading = false;
          }
        );
      }
    }
  }
}
